import Vue from 'vue';
import {round} from 'mathjs'

const isServer = Vue.prototype.$isServer;

// 节流函数
export function throttle() {
  let startTime = Date.now(), timer;
  return function ({callback, delay = 500, arg = []}) {
    let currentTime = Date.now, _this = this;
    if (currentTime - startTime > delay) {
      callback.apply(_this, arg);
      startTime = currentTime
    } else {
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(_this, arg)
      }, delay)
    }
  }
}

// 格式化金额
//flag 为需要展示的金额的string类型，用于保留小数0
export function formatPrice(num,flag) {
  num = num * 1;
  let str = round(num,window.oprInfo ? window.oprInfo.accuracy : 2) + '';
  if(isNaN(num)) str = num.toFixed(window.oprInfo ? window.oprInfo.accuracy : 2) + ''
  let arr = str.split('.'),
    int = arr[0] * 1,
    decimals = arr[1] * 1;
  if (arr.length !== 2) return num;
  if (decimals > 0) {
    return flag ? str : str * 1
  } else if (int > 0) {
    return int
  } else {
    return 0
  }
}

export function format(value, fmt = 'yyyy-MM-dd hh:mm:ss') {
  if (!value) return value;
  let date = new Date(value - 0),
  o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}
export function calculateNum(...args) { // 多个数字操作 //最后参数操作符
  let num = 0, action = args.pop(), list = args.map(value => {
    let [intNum = 0, decimalNum = 0 ] = (value + '').split('.');
    return (intNum*1000) + (decimalNum > 0? decimalNum * (1000/Math.pow(10,decimalNum.length)) : 0)
  });
  if (['*', '+', '-', '/'].indexOf(action)) {
    num = eval(list.join(action));
  }
  return num/1000;
}
// 格式化时分秒
export function formatTime(value, fmt = 'hh:mm:ss') {
  value = value * 1;
  if (typeof value !== 'number') return;
  let s = 1000,
    m = s * 60,
    h = m * 60,
    o = {};
  o['h+'] = Math.floor(value / h);
  o['m+'] = Math.floor((value % h) / m);
  o['s+'] = Math.floor(value % h % m / s);
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

// 验证手机号码和固定号码
export function isTel(value) {
  let pattern = /(^1[1-9]\d{9}$)|(^0\d{2,3}-?\d{7,8}$)/ig;
  return pattern.test(value)
}
// 查找
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

export function deepClone(parent, child) {
  if (typeof parent === "object") {
    let key, proxy, child = child || {};
    proxy = JSON.stringify(parent);
    proxy = JSON.parse(proxy);
    for (key in proxy) {
      if (proxy.hasOwnProperty(key)) {
        child[key] = proxy[key]
      }
    }
    proxy = null;
    return child
  }
}

export function find(list, callback) {
  if (list) {
    for (let key in list) {
      let value = list[key];
      if (value && callback.call(value, value, key, list)) return {index: key, value}
    }
  }
}

export function each(list, callback) {
  if (list) {
    if (list.length) {
      for (let i = 0, len = list.length; i < len; i++) {
        if (list[i] || list[i] == 0) callback.call(this, list[i], i, list)
      }
    } else {
      for (let key in list) {
        if (list[key] || list[key] == 0) {
          callback.call(this, list[key], key, list)
        }
      }
    }
  }
}

export function keys(value) {
  let arr = [],
    obj = {};
  for (let key in value) {
    obj[key] = true
  }
  for (let key in obj) {
    arr.push(key)
  }
  return arr
}

export function values(list) {
  let arr = [];
  for (let key in list) {
    arr.push(list[key])
  }
  return arr
}

export function isEmptyObject(obj) {
  if (typeof obj === 'object') {
    return Object.keys(obj).length === 0
  }
  return true
}

export function cloneObjects(target, ...params) {
  Object.assign(target, ...params);
  target = JSON.parse(JSON.stringify(target));
  return target;
}

// 获取链接上的参数
export function getUrlParameter() {
  const url = {};
  const urlSearch = window.location.search;
  if (urlSearch) {
    let urlSearch_temp = urlSearch.split("?");
    if (urlSearch_temp.length > 1) {
      let urlSearch_temp2 = urlSearch_temp[1].split("&");
      urlSearch_temp2.forEach(d => {
        if (d.indexOf("=") > 0) {
          let urlSearch_temp3 = d.split("=");
          if (urlSearch_temp3.length > 1 && urlSearch_temp3[0] !== "") {
            url[urlSearch_temp3.shift()] = decodeURIComponent(urlSearch_temp3.join("="));
          }
        }
      })
    }
  }
  return url
}

// 是否是八喜key
export function isBaXi(platformKey) {
	let bool = false
	// e5485003f51054cb 八喜生产key
	if (["cfffb941289a08f9","e07e4d84b33de42c","09e1f11431360df5","eed84f190fa141e6","eed84f190fa141e6","e5485003f51054cb"].includes(platformKey)) {
		bool = true 
	}
	return bool;
}


// WEBPACK FOOTER //
// ./utils/assist.js